import { CampaignState } from "../api/queries";

export const statusOfState = (state: CampaignState) => {
  switch (state) {
    case CampaignState.CREATED: {
      return "Creata";
    }
    case CampaignState.TO_PAY: {
      return "Da pagare";
    }
    case CampaignState.ERR_PAY: {
      return "Insoluta";
    }
    case CampaignState.TO_VERIFY: {
      return "In verifica";
    }
    case CampaignState.REJECTED: {
      return "Rifiutata";
    }
    case CampaignState.APPROVED: {
      return "Approvata";
    }
    case CampaignState.IN_PROGRESS: {
      return "Attiva";
    }
    case CampaignState.COMPLETED: {
      return "Conclusa";
    }
  }
}
